import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { LoginMFA } from '../types/LoginSchema'
import { LAST_MFA_DATA } from '../lib/consts'

export interface LoginServiceProps {
	login: string
	password: string
}

export const loginService = createAsyncThunk<
	LoginMFA,
	LoginServiceProps,
	ThunkConfig<string>
>('login/loginService', async ({ login, password }, thunkAPI) => {

	const { extra: { api }, rejectWithValue } = thunkAPI

	try {
		const { data: loginMfaResponse } = await api.post<LoginMFA>('/login', {
			login,
			password
		})

		sessionStorage.setItem(LAST_MFA_DATA, JSON.stringify(loginMfaResponse))
		return loginMfaResponse
	} catch (e: any) {
		console.log(e)
		const message = e.response?.data?.message || e.message
		showToast({ message, type: 'error' })
		return rejectWithValue(message)
	}
})
